import { formatDateForDisplay, formatRelativeDate } from "utils/utils";

export const DateCell = (info) =>
  formatDateForDisplay(info.getValue(), { addSuffix: true });

export const RelativeDateCell = (info) =>
  formatRelativeDate(info.getValue(), { addSuffix: true });
